import React, { useContext } from "react";
import { AppContext } from "../../context";
import Footer from "../Common/Footer";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  newCheckout: {
    display: "flex",
    flexDirection: "column",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
}));

const ContentLayout = ({ children }) => {
  const {
    state: {
      config: { useFooter },
    },
  } = useContext(AppContext);
  const { classes } = useStyles();

  return (
    <div className={`${classes.container} contentLayoutContainer`}>
      <div className={classes.newCheckout}>{children}</div>
      {useFooter && <Footer />}
    </div>
  );
};

export default ContentLayout;
